/**
 * @file Public landing page — pages/Landing/JoinPage.tsx.
 */

import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./LandingPage.css";
import "./JoinPage.css";

const JoinPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="landing-root">
      {/* Top Header */}
      <header className="landing-header flex justify-center items-center space-x-3 text-center py-4">
        <h1 className="landing-main-title text-4xl font-bold text-primary">
          ICoMEC
        </h1>
        <h2 className="landing-sub-title text-xl text-grayDark">
          Indian Construction Materials Embodied Carbon Data Base
        </h2>
      </header>

      {/* Navigation Bar */}
      <nav className="landing-nav">
        <Link to="/">Home</Link>
        <Link to="/join">Join</Link>
        <Link to="/impact">Impact</Link>
        <Link to="/research">Research and Analysis</Link>
        <Link to="/about">About</Link>
      </nav>

      {/* Content Section */}
      <section className="join-content">
        <h1 className="join-title">Join</h1>
        
        <p className="join-intro">
          Reliable embodied carbon data is the foundation for low-carbon decision-making in the built environment.
        </p>
        
        <p className="join-description">
          ICoMEC's dashboard is designed as a living, evolving knowledge infrastructure, and it grows stronger through collaboration.
          We invite researchers, practitioners, manufacturers, policymakers, and institutions to contribute, review, and use data responsibly.
        </p>

        <div className="join-contribute-section">
          <h2 className="join-section-title">How you can contribute:</h2>
          <ul className="join-contribute-list">
            <li>Submit published or unpublished datasets</li>
            <li>Participate in data review and validation</li>
            <li>Use the data and provide feedback for improvement</li>
          </ul>
        </div>

        <p className="join-goal">
          Our goal is traceable, contextual, and decision-ready data.
        </p>

        <p className="join-cta">
          Join us in building India's embodied carbon evidence base, together.
        </p>

        <div className="join-buttons">
          <button 
            className="join-btn join-btn-primary"
            onClick={() => navigate("/signup")}
          >
            Join as Contributor
          </button>
          <button 
            className="join-btn join-btn-secondary"
            onClick={() => navigate("/partners")}
          >
            Partner with Us
          </button>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="footer-main">
          <div className="footer-left">
            <h2>ICoMEC</h2>
            <p>
              Indian Construction Materials Embodied
              <br /> Carbon Data Base
            </p>
          </div>

          <div className="footer-links">
            <div>
              <h4>About Us</h4>
              <ul>
                <li><Link to="/who-we-are">Who We Are</Link></li>
                <li><Link to="/what-we-do">What We Do</Link></li>
                <li><Link to="/leadership">Leadership</Link></li>
                <li><Link to="/partners">Partners</Link></li>
                <li><Link to="/faq">FAQ</Link></li>
                <li><Link to="/glossary">Glossary</Link></li>
              </ul>
            </div>
            <div>
              <h4>Resources</h4>
              <ul>
                {/* <li><Link to="/resource-library">Resource Library</Link></li> */}
                <li><Link to="/events">Events</Link></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>
          <Link to="/cookies-policy">Cookies Policy</Link> · <Link to="/privacy-policy">Privacy Policy</Link> · <Link to="/legal">Legal</Link> · <Link to="/terms-of-use">Terms of Use</Link>
          {/* · <Link to="/imprint">Imprint</Link> */}
        </p>
        <p>© 2026 CARBSE. All rights reserved.</p>
      </div>
    </div>
  );
};

/** React component — Join Page. */
export default JoinPage;

